export { QUESTION_RESPONSE_TYPE_MAP } from 'bundles/onboarding-2022/data/constants';

export const ONBOARDING_SURVEY_BASE_ID = 'afUpDK-8TR-tghPy38a67w';
export const ONBOARDING_SURVEY_VERSION = 9;
